import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { PROD, PIT_ROLES } from "../../../common/constants";
import { Box, Button, Tooltip } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { QuickSearchToolbar } from "../../../payment/common/commonFunctions";
import { GET_CONSIGNMENT_LIST, GET_STAKEHOLDER_CATEGORY, DELETE_CONSIGNMENT, UPDATE_CONSIGNMENT } from "../../../common/URLs";
import moment from 'moment';
import { loaderService } from "../../../common/custom-loader/loader-service";

import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import jwt from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import { DialogContent, IconButton, Dialog, DialogActions } from '@mui/material';
import { ConfirmPopover } from "../../../preregcamps/confirmPopover/confirmPopover";
import DeleteIcon from '@mui/icons-material/Delete';
import { CardContent, Card, Typography, Stack, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { UpdateConsignmentPopup } from "../weeklyConsignment/updateConsignmentDetails";
import { useTranslation } from "react-i18next";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";

function ConsignmentPickupTracker() {
    const { t } = useTranslation();
    const { state } = useLocation();
    const [consignmentListData, setConsignmentListData] = useState();
    const navigate = useNavigate();
    const [tabValue, setTabValue] = React.useState(state?.tabValue ? state?.tabValue : 'RawBamboo');

    const columns = [
        { field: 'consignmentNumber', headerName: t('pit.consignmentNo'), width: 130 },
        { field: 'consignmentStatus', headerName: t('pit.consignmentStatus'), width: 200 },
        { field: 'pickUpLocationURN', headerName: t('pit.sourceUrn'), width: 150 },
        {
            field: 'pickUpLocationAddress', headerName: t('pit.sourceLocation'), width: 200,
            renderCell: (params) => (
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
                    {params.value}
                </div>
            ),
            valueGetter: (params) => params.value
        },
        { field: 'deliveryLocationURN', headerName: t('pit.destinationUrn'), width: 150 },
        {
            field: 'deliveryLocationAddress', headerName: t('pit.destinationLocation'), width: 200,
            renderCell: (params) => (
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
                    {params.value}
                </div>
            ),
            valueGetter: (params) => params.value
        },
        { field: 'vehicleRegistration', headerName: t('pit.vehicleNo'), width: 110 },
        { field: 'totalWeight', headerName: t('pit.quantity'), width: 100 },
        {
            field: t('reg.actions'), width: 130,
            renderCell: (cellValue) => {
                return (
                    <Tooltip title={t('pit.view')}>
                        <IconButton variant="contained" style={{ marginTop: "1vh", marginBottom: "1vh" }}
                            color="primary"
                            onClick={() => onViewClick(cellValue?.row?.consignmentNumber)}
                        ><ViewIcon /></IconButton>
                    </Tooltip>
                );
            }
        }
    ];

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    useEffect(() => {
        getConsignmentList();
    }, [tabValue]);

    const getConsignmentList = () => {
        loaderService.showLoader();
        apiClient
            .post(GET_CONSIGNMENT_LIST,
                {
                    materialType: tabValue,
                    isPickupBundlesSelected: true,
                    roleType: localStorage.getItem('role') ? localStorage.getItem('role') : '',
                    loginId: localStorage.getItem('InspectorEmail') ? localStorage.getItem('InspectorEmail') : ''
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token')
                    },
                },
                null
            ).then((response) => {
                setConsignmentListData(response.data.consignmentList);
                // getConsignmentList();
                loaderService.hideLoader()
            }).catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const onViewClick = (consignmentNo) => {
        navigate("./LlePickUpDetails", {
            state: { selectedConsNo: consignmentNo, tabValue: tabValue, pageName: 'consignmentPickupTracker' }
        });
    }

    return (
        <>
            <Container fluid>
                <Card>
                    <>
                        <TabContext value={tabValue}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList onChange={handleTabChange}>
                                    <Tab label="RB Consignments" value="RawBamboo" />
                                    <Tab label="CB Consignments" value="ChipBamboo" />
                                </TabList>
                            </Box>
                            <TabPanel value="RawBamboo">
                                <Box sx={{ height: 450, width: "100%" }}>
                                    {consignmentListData &&
                                        <DataGrid
                                            rows={consignmentListData}
                                            columns={columns}
                                            getRowHeight={() => 'auto'}
                                            getRowId={(row) => row.consignmentNumber}
                                            pageSize={10}
                                            rowsPerPageOptions={[5]}
                                            components={{ Toolbar: QuickSearchToolbar }}
                                            experimentalFeatures={{ newEditingApi: true }}
                                        />
                                    }
                                </Box>
                            </TabPanel>
                            <TabPanel value="ChipBamboo">
                                <Box sx={{ height: 450, width: "100%" }}>
                                    {consignmentListData &&
                                        <DataGrid
                                            rows={consignmentListData}
                                            columns={columns}
                                            getRowHeight={() => 'auto'}
                                            getRowId={(row) => row.consignmentNumber}
                                            pageSize={10}
                                            rowsPerPageOptions={[5]}
                                            components={{ Toolbar: QuickSearchToolbar }}
                                            experimentalFeatures={{ newEditingApi: true }}
                                        />
                                    }
                                </Box>
                            </TabPanel>
                        </TabContext>
                    </>

                </Card>
            </Container>
        </>
    )
}
export default ConsignmentPickupTracker;